import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/components/Common";
import { Page, PageHeader, Loading } from "@/components/Common";

const GROUPS = [
  { key: "authors", label: "شعراء و ادباء", path: (x) => `/authors/${x.slug}`, title: (x) => x.name },
  { key: "works", label: "تصانیف و متون", path: (x) => `/works/${x.slug}`, title: (x) => x.title },
  { key: "articles", label: "تنقید و تحقیق", path: (x) => `/articles/${x.slug}`, title: (x) => x.title },
  { key: "genres", label: "اصنافِ ادب", path: (x) => `/genres/${x.slug}`, title: (x) => x.title },
  { key: "eras", label: "تاریخِ ادب", path: (x) => `/history/${x.slug}`, title: (x) => x.title },
  { key: "pages", label: "UGC NET صفحات", path: (x) => `/pages/${x.slug}`, title: (x) => x.title },
];

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [results, setResults] = useState(null);

  useEffect(() => {
    if (!q) return;
    setResults(null);
    api.get(`/search?q=${encodeURIComponent(q)}`).then((r) => setResults(r.data)).catch(() => setResults({}));
  }, [q]);

  const total = results ? GROUPS.reduce((n, g) => n + (results[g.key]?.length || 0), 0) : 0;

  return (
    <Page>
      <PageHeader title={`تلاش: ${q}`} subtitle={results ? `${total} نتائج ملے` : undefined} testid="search-results-title" />
      {!results ? (
        <Loading />
      ) : total === 0 ? (
        <p className="text-center text-xl text-[#5c3a21] py-16" data-testid="search-empty">کوئی نتیجہ نہیں ملا</p>
      ) : (
        <div className="space-y-10" data-testid="search-results">
          {GROUPS.map((g) =>
            results[g.key]?.length ? (
              <section key={g.key}>
                <h2 className="text-2xl font-bold text-[#2a1508] mb-4 leading-[2] border-b border-[#d4af37]/40 pb-2">{g.label}</h2>
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  {results[g.key].map((item) => (
                    <Link
                      key={item.slug}
                      to={g.path(item)}
                      data-testid={`search-result-${item.slug}`}
                      className="block bg-[#fdfbf7] border border-[#d4af37]/40 rounded-xl px-5 py-4 text-lg text-[#2a1508] leading-[2] hover:border-[#d4af37] hover:-translate-y-0.5 transition-all duration-300"
                    >
                      {g.title(item)}
                    </Link>
                  ))}
                </div>
              </section>
            ) : null
          )}
        </div>
      )}
    </Page>
  );
}
